/** Line icons drawn on a 24-unit grid, coloured by `currentColor` through
 *  `svg.ic` in `styles.css`. Inline so they need no request and no cache. */
const icon = (paths: string) =>
  `<svg class="ic" viewBox="0 0 24 24" aria-hidden="true">${paths}</svg>`;

export const ICON = {
  qr: icon(`<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M21 14v7h-4M14 21v-2"/>`),
  scan: icon(`<path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M4 12h16"/>`),
  errand: icon(`<path d="M4 6h16v12H4z"/><path d="m4 7 8 6 8-6"/>`),
  history: icon(`<circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/>`),
  more: icon(`<circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/>`),
  shield: icon(`<path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6z"/>`),
  phone: icon(`<rect x="6" y="2" width="12" height="20" rx="2"/><path d="M11 18h2"/>`),
  logout: icon(`<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"/>`),
  plus: icon(`<path d="M12 5v14M5 12h14"/>`),
  receive: icon(`<path d="M12 4v12M6 10l6 6 6-6M4 20h16"/>`),
  close: icon(`<path d="M6 6l12 12M18 6 6 18"/>`),
  back: icon(`<path d="M15 6l-6 6 6 6"/>`),
  forward: icon(`<path d="m9 6 6 6-6 6"/>`),
  download: icon(`<path d="M12 3v12M7 10l5 5 5-5M5 21h14"/>`),
  share: icon(`<path d="M12 3v12M8 7l4-4 4 4M6 11H5v10h14V11h-1"/>`),
  homeScreen: icon(`<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M12 8v8M8 12h8"/>`),
  check: icon(`<path d="m5 12 5 5 9-10"/>`),
  cross: icon(`<path d="M7 7l10 10M17 7 7 17"/>`),
  person: icon(`<circle cx="12" cy="8.5" r="3.6"/><path d="M4.5 20c.6-3.9 3.6-6.2 7.5-6.2s6.9 2.3 7.5 6.2"/>`),
  camera: icon(`<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>`),
  offline: icon(`<path d="M2 8.8a15 15 0 0 1 20 0M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M12 20h.01"/>`),
};
